import React, { ReactNode } from "react";
import {
  WixDesignSystemDefaultPropsProvider,
  WixDesignSystemIconThemeProvider,
  WixDesignSystemProvider,
} from "@wix/design-system";
import { IconThemeProvider } from "@wix/wix-ui-icons-common/core";

/** Business Manager redesign defaults (odeditor theme). */
const defaults = {
  Button: { size: "small", skin: "dark" },
  IconButton: { size: "small", skin: "dark", priority: "tertiary" },
  TextButton: { size: "small", skin: "standard" },
  Input: { size: "small" },
} as const;

export function WdsProviders({ children }: { children: ReactNode }) {
  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <WixDesignSystemIconThemeProvider>
        <IconThemeProvider theme="odeditor">
          <WixDesignSystemDefaultPropsProvider defaults={defaults}>
            {children}
          </WixDesignSystemDefaultPropsProvider>
        </IconThemeProvider>
      </WixDesignSystemIconThemeProvider>
    </WixDesignSystemProvider>
  );
}
